import React, { useEffect } from 'react'

/**
 * Sticky banner displayed at the top of the page in preview mode.
 * Indicates to the item owner that they are viewing a draft preview.
 */
function PreviewBanner() {
  useEffect(() => {
    const navHeader = document.getElementById('navigation-header')
    if (!navHeader) return

    const updatePosition = () => {
      document.documentElement.style.setProperty(
        '--preview-banner-top',
        `${navHeader.offsetHeight}px`
      )
    }

    const observer = new ResizeObserver(updatePosition)
    observer.observe(navHeader)
    updatePosition()

    return () => observer.disconnect()
  }, [])

  return (
    <div className="preview-banner">
      <div className="preview-banner__content">
        <span className="preview-banner__text">Preview</span>
      </div>
    </div>
  )
}

export default PreviewBanner
